<template lang="html">
    <section class="diarization">
        <h3>{{ t('Speaker Diarization With Vonage Video and Deepgram') }}</h3>
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--1of2">
                <div v-if="gotToken">
                    <session v-if="gotToken" :nexmo="nexmo" :sessionId="sessionId" :token="token" :apiKey="apiKey"
                        @gotPublisher="doStart" @gotSession="gotSession" />
                </div>
            </div>
            <div class="Vlt-col Vlt-col--1of2">
                <chat :key="key" :nexmo="nexmo" :newMessage="newChat"></chat>
                <vlt-button :label="t('Clear')" secondary app @click="clear" />
            </div>
            <div v-if="false" class="Vlt-col--1of3">
                <vlt-field :label="t('Number to send invitation to')">
                    <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" color="#131415"
                        :no-validator-state=true :default-country-code="nexmo.region" v-model="prettyNumber"
                        @update="onUpdate" />
                </vlt-field>
                <vlt-button :label="t('Send the Invitation')" secondary app @click="sendText"
                    :disabled="(!message) || (!isValid)" />
                <br />
                <br />
                <vlt-button :label="t('Copy Link to Clipboard')" secondary app @click="copy" />
                <br />
                <br />
                <div class="Vlt-card Vlt-card--border">
                    <h4>{{ t('Or, click the link to add a new client window:') }} </h4>
                    <vlt-button :label="t('Open Another Video')" secondary app @click="openWindow" />
                </div>
            </div>
        </div>
        <vlt-button :label="t(btnText)" quaternary app @click="startStop" />
        <div v-if="summaries.length" class="Vlt-grid">
            <div class="Vlt-table Vlt-table--data Vlt-table--cols">
                <table>
                    <thead>
                        <tr>
                            <th>{{ t('Date') }}</th>
                            <th>{{ t('Summary') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="summary in summaries">
                            <td>{{ summary.timestamp }}</td>
                            <td>{{ summary.message }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {
    $NODEBASE
} from '@/base';
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import session from "./Session";
import {
    $BASE
} from '@/base';
import axios from 'axios';
import chat from './chat';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
} from "@vonagevolta/vue";
export default {
    name: 'diarization',
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        }

    },
    data() {
        return {
            number: '',
            prettyNumber: '',
            numberStuff: {},
            incoming: [],
            message: 'Join the Video Chat ',
            sessionId: '',
            token: '',
            apiKey: null,
            gotToken: 0,
            url: '',
            isValid: true,
            pusher: {},
            flavor: 'diarization',
            DEMO: {},
            publisher: {},
            newChat: {},
            files: [
                "https://vids.vonage.com/vader/deal.mp3",
                "https://vids.vonage.com/vader/dontfail.mp3",
                "https://vids.vonage.com/vader/failed.mp3",
                "https://vids.vonage.com/vader/proud.mp3",
                "https://vids.vonage.com/vader/remembered.mp3",
                "https://vids.vonage.com/vader/skills.mp3",
                "https://vids.vonage.com/vader/traitor.mp3",
                "https://vids.vonage.com/vader/weak.mp3",
            ],
            started: false,
            btnText: "Stop Captions and Produce Summary",
            key: "",
            summaries: [],
            session: null,
            AC: null,
        }
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "session": session,
        "chat": chat,
    },
    watch: {
        lang: function (newVal) {
            // Any strings that need to be dynamically changed on Language Change go here...
            this.message = this.t(this.message);
        }
    },
    methods: {
        clear() {
            this.key = new Date().getTime();
        },
        play(index) {
            var audio = new Audio(this.files[index]);
            audio.volume = 0.5;
            audio.play();
        },
        startStop() {
            if (this.started) {
                this.doStop()
            } else {
                this.doStart();
            }
        },
        doStop() {
            if (this.session && this.AC?.connectionId) {
                console.log("FORCING DISCNNECT!!!")
                //this.session.forceDisconnect(this.AC.connectionId);
            }
            this.DEMO.post('/stop', {});
            this.started = false;
            this.btnText = "Start Captions";
        },
        gotSession(session) {
            console.log("Diarization, got session");
            this.session = session;
        },
        doStart(publisher) {
            if (publisher) {
                console.log("Top Level Emitted publisher: ", publisher)
                this.publisher = publisher;
            }
            this.startDiarization(this.publisher.streamId);
            this.btnText = "Stop Captions and Produce Summary";
            this.started = true;
        },
        openWindow() {
            window.open(this.url, '_blank');
        },
        copy() {
            let aThis = this;
            this.$copyText(this.url).then(function (e) {
                aThis.$swal(aThis.t('Success'),
                    aThis.t('The URL has been copied to the clipboard.'),
                    'success');
            }, function (e) {
                console.log(e)
            })
        },
        sendText() {
            console.log("To " + this.number + " we send: " + this.message);
            let message = this.message + " " + this.url;
            $HTTPDEMO.post('opentokDemo.php/send', {
                to: this.number,
                message: message
            });
            this.$swal(this.t('Success'),
                this.t('The Text Invitation has been sent to') + ' ' + this.numberStuff.formatInternational + '.',
                'success');
        },
        async register() {
            console.log("Registering the Demo Component with the associated backend");
            let res = await this.DEMO.post('/register');
            console.log("Register: ", res.data);
            if (res) {
                this.sessionId = res.data.session.sessionId;
                this.token = res.data.session.token;
                this.apiKey = res.data.session.apiKey;
                this.gotToken = 1;
                console.log("Got SessionID=" + this.sessionId + " Token=" + this.token);
            }
        },
        async startDiarization(streamId) {
            console.log("Start diarization on the backend: ", this.lang?.thisCode);
            setTimeout(async () => {
                let res = await this.DEMO.post('/start', {
                    streamId: streamId,
                    language: this.lang ? this.lang.thisCode : "en-US"
                });
                this.AC = res.data;
                console.log("Started: ", this.AC);
            }, 1000);
        },
        onUpdate(payload) {
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        process(data) {
            if (data.event == "caption") {
                this.newChat = data;
            } else {
                this.newChat = data;
                var date = new Date().toLocaleString();
                this.summaries.unshift({
                    timestamp: date,
                    message: data.message
                });
            }
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang, this.baseLang)
        },
    },
    created() {
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.pusher = pusher;
        this.channel = pusher.subscribe(this.flavor);
        this.channel.bind("event_" + this.nexmo.userid, data => {
            console.log("Got some OpenTok data: " + JSON.stringify(data));
            this.process(data);
        });
        var postscript = "/" + this.flavor;
        if ($NODEBASE.indexOf("ngrok") > 0) {
            postscript = "";
        }
        this.DEMO = axios.create({
            baseURL: $NODEBASE + postscript,
            headers: {
                "Content-Type": "application/json",
            },
        });
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        );
        this.register();
    },
    beforeDestroy() {
        console.log("beforeDestroy for opentokDemo")
        if (this.pusher) {
            this.pusher.unsubscribe("openTok");
        }
        this.DEMO.post('/stop', {});
    },
    mounted() {
        //let recaptchaScript = document.createElement('script')
        //recaptchaScript.setAttribute('src', 'node_modules/nexmo-client/dist/conversationClient.js');
        //document.head.appendChild(recaptchaScript)
    },
}
</script>

<style lang="scss" scoped></style>
